import React from "react";

const Profile = () => {
   
    return (
        <div className="w-full h-full"></div>
    );
}
export default Profile;